// API接口路径配置

// 认证相关接口
export const AUTH_PATHS = {
  // 用户登录
  LOGIN: '/auth/login',
  // 获取用户信息
  GET_USER_INFO: '/auth/user',
  // 用户退出
  LOGOUT: '/auth/logout',
  // 刷新token
  REFRESH_TOKEN: '/auth/refresh'
}

// 用户相关接口
export const USER_PATHS = {
  // 获取用户列表
  GET_USER_LIST: '/users/list',
  // 根据ID获取用户
  GET_USER_BY_ID: '/users/getById',
  // 创建用户
  CREATE_USER: '/users/create',
  // 更新用户信息
  UPDATE_USER: '/users/update',
  // 删除用户
  DELETE_USER: '/users/delete',
  // 更新用户文档访问权限
  UPDATE_USER_PERMISSIONS: '/users/updatePermissions'
}

// 文档相关接口
export const DOCUMENT_PATHS = {
  // 获取文档列表
  GET_DOCUMENT_LIST: '/documents/list',
  // 获取我的文档
  GET_MY_DOCUMENTS: '/documents/my',
  // 创建文档
  CREATE_DOCUMENT: '/documents/create',
  // 获取文档详情
  GET_DOCUMENT: '/documents/detail',
  // 更新文档
  UPDATE_DOCUMENT: '/documents/update',
  // 删除文档
  DELETE_DOCUMENT: '/documents/delete',
  // 复制文档
  COPY_DOCUMENT: '/documents/copy',
  // 搜索文档（全文搜索）
  SEARCH_DOCUMENTS: '/documents/search'
}

// 文集相关接口
export const COLLECTION_PATHS = {
  // 获取文集列表
  GET_COLLECTION_LIST: '/collections/list',
  // 分页获取文集列表
  GET_COLLECTION_PAGE: '/collections/page',
  // 获取文集详情
  GET_COLLECTION_DETAIL: '/collections/detail',
  // 获取我的文集
  GET_MY_COLLECTIONS: '/collections/my',
  // 创建文集
  CREATE_COLLECTION: '/collections/create',
  // 复制文集
  COPY_COLLECTION: '/collections/copy',
  // 更新文集
  UPDATE_COLLECTION: '/collections/update',
  // 删除文集
  DELETE_COLLECTION: '/collections/delete'
}

// 目录相关接口
export const CATEGORY_PATHS = {
  // 获取目录树（含文档）
  GET_TREE: '/categories/tree',
  // 获取所有目录列表
  GET_LIST: '/categories/list',
  // 获取根目录
  GET_ROOTS: '/categories/roots',
  // 获取子目录
  GET_CHILDREN: '/categories/children',
  // 创建目录
  CREATE: '/categories/create',
  // 更新目录
  UPDATE: '/categories/update',
  // 删除目录
  DELETE: '/categories/delete'
}

// 系统相关接口
export const SYSTEM_PATHS = {
  // 获取系统配置
  GET_SYSTEM_CONFIG: '/system/config',
  // 更新系统配置
  UPDATE_SYSTEM_CONFIG: '/system/update',
  // 获取系统日志
  GET_SYSTEM_LOGS: '/system/logs'
}

// 文档分享相关接口
export const DOCUMENT_SHARE_PATHS = {
  // 创建分享链接
  CREATE_SHARE: '/document-shares/create',
  // 通过token查看文档
  VIEW_SHARE: '/document-shares/view',
  // 更新滚动位置
  UPDATE_SCROLL: '/document-shares/update-scroll'
}

// 导出所有接口路径 
export default {
  ...AUTH_PATHS,
  ...USER_PATHS,
  ...DOCUMENT_PATHS,
  ...COLLECTION_PATHS,
  ...CATEGORY_PATHS,
  ...SYSTEM_PATHS,
  ...DOCUMENT_SHARE_PATHS
}

